function cfgDrawBarsNew(currGraphicData, interestArray, interestArrayBonus) {
    return {
        initial: {
            label: 'Исходные данные',
            backgroundColor: currGraphicData.colors,
            hoverBackgroundColor: currGraphicData.colors,
            data: interestArray,
            interest: currGraphicData.interest,
            barPercentage: 0.7,
            categoryPercentage: 0.7,
            maxBarThickness: 64,
        },
        bonus: {
            label: 'Дополнительные данные',
            backgroundColor: currGraphicData.colorsBonus,
            hoverBackgroundColor: currGraphicData.colorsBonus,
            data: interestArrayBonus,
            interest: currGraphicData.interestBonus,
            barPercentage: 0.7,
            categoryPercentage: 0.7,
            maxBarThickness: 64,
        },
    };
}

export default cfgDrawBarsNew;




// WEBPACK FOOTER //
// ./_src/js/cfgGraphics/drawBarsNew.js